import { render, staticRenderFns } from "./DisplayApplications.vue?vue&type=template&id=28ecb47c&"
import script from "./DisplayApplications.vue?vue&type=script&lang=js&"
export * from "./DisplayApplications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports